import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faTractor } from '@fortawesome/free-solid-svg-icons';
import { BasketContext } from './BasketContext';

function NavBar() {
  const { basket } = useContext(BasketContext);


  const basketTotalItems = basket.reduce((total, item) => total + item.quantity, 0);

  return (
    <nav>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li>
          <div className="dropdown">
            <Link to="#" className="dropbtn"><FontAwesomeIcon icon={faPlay} className="nav-arrow" />Products</Link>
            <div className="dropdown-content">
              <Link to="/products">Information</Link>
              <Link to="/compare">Compare</Link>
            </div>
          </div>
        </li>
        <li>
          <div className="dropdown">
            <Link to="#" className="dropbtn"><FontAwesomeIcon icon={faPlay} className="nav-arrow" />Tools & Apps</Link>
            <div className="dropdown-content">
              <Link to="/grass">Grass Finder</Link>
              <Link to="/maize">Maize Selector</Link>
              <Link to="/mixer">Seed Mixer</Link>
            </div>
          </div>
        </li>
        <li>
          <div className="dropdown">
            <Link to="/about-us" className="dropbtn"><FontAwesomeIcon icon={faPlay} className="nav-arrow" />About Us</Link>
            <div className="dropdown-content">
              {/*<Link to="/team">Meet the Team</Link>*/}
              <Link to="/contact">Contact Us</Link>
              <Link to="/agents">Agent Finder</Link>
              <Link to="/careers">Careers</Link>
            </div>
          </div>
        </li>
        <li>
          <div className="dropdown">
            <Link to="#" className="dropbtn"><FontAwesomeIcon icon={faPlay} className="nav-arrow" />News</Link>
            <div className="dropdown-content">
              <Link to="/blogs">Blogs</Link>
              <Link to="/videos">Videos</Link>
            </div>
          </div>
        </li>
        <li>
          <Link to="/tractor">
            <FontAwesomeIcon icon={faTractor} />
            {basketTotalItems > 0 && <span>&nbsp;({basketTotalItems})</span>}
          </Link>
        </li>
      </ul>
    </nav>
  );
}

export default NavBar;
